import { defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
import { useModal } from '~/composables';
import { CLUB_FACE_LABELS } from '~/components/ClubFaceLabel';
export default defineComponent({
    name: 'ProfileClubFaceCard',
    props: {
        profile: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const modal = useModal();
        const isOpened = ref(false);
        function handleBlackout() {
            isOpened.value = false;
        }
        function getDate(date) {
            return new Date(date)
                .toLocaleDateString('ru-RU', { day: '2-digit', month: 'long', year: 'numeric' })
                .replace(' г.', '');
        }
        function openModal() {
            isOpened.value = !isOpened.value;
            modal.open('clubBiographyModal', {
                componentAttrs: {
                    title: 'Биография',
                    body: props.profile.body,
                },
            });
        }
        return {
            css,
            handleBlackout,
            getDate,
            isOpened,
            CLUB_FACE_LABELS,
            openModal,
        };
    },
});
